import {
  VoyagerKeyType,
  VoyagerLeadsSearchQuery,
  VOYAGER_FRIENDLY_NAMES,
} from '@mm/state/interfaces/voyagerLeads';
import React from 'react';
import { Tag } from 'antd';
import styles from './VoyagerFiltersBar.module.css';
import { CloseOutlined } from '@ant-design/icons';
import { uniqueId } from 'lodash';

type Props = {
  voyagerSearchQuery: VoyagerLeadsSearchQuery;
  setVoyagerSearchQuery: (params: VoyagerLeadsSearchQuery) => void;
  getUpdatedQuery: (
    state: VoyagerLeadsSearchQuery,
    key: VoyagerKeyType,
    value: string,
    operator?: 'not_in',
  ) => VoyagerLeadsSearchQuery;
};

type VoyagerTagType = {
  key: VoyagerKeyType;
  name: string;
  value: string;
  operator?: 'not_in';
};

export const VoyagerFiltersBar = ({
  voyagerSearchQuery,
  setVoyagerSearchQuery,
  getUpdatedQuery,
}: Props) => {
  const hasFilters = !!voyagerSearchQuery.query.length;

  const tags = voyagerSearchQuery.query.flatMap(item =>
    item.values.map(
      v =>
        ({
          key: item.field,
          name: VOYAGER_FRIENDLY_NAMES[item.field],
          value: v,
          operator: item.operator,
        } as VoyagerTagType),
    ),
  );

  const onTagRemove = (tag: VoyagerTagType) => {
    const updatedQuery = getUpdatedQuery(
      voyagerSearchQuery,
      tag.key,
      tag.value,
      tag.operator,
    );
    setVoyagerSearchQuery(updatedQuery);
  };

  const onResetAll = () => {
    setVoyagerSearchQuery({ query: [] });
  };

  if (!hasFilters) {
    return <></>;
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {Boolean(hasFilters) && (
          <Tag
            color="default"
            closable
            closeIcon={<CloseOutlined className={styles.closeIcon} />}
            onClose={onResetAll}
            onClick={onResetAll}
            className={styles.resetAll}
          >
            Reset All
          </Tag>
        )}
        {tags.map(tag => {
          const key = `${uniqueId(tag.name)}`;
          return (
            <Tag
              key={key}
              color="geekblue"
              className={styles.tag}
              closable
              onClose={() => onTagRemove(tag)}
            >
              <span className={styles.fatTag}>
                {' '}
                {tag.operator === 'not_in' ? `Excluding ${tag.name}` : tag.name}
                :
              </span>{' '}
              {tag.value}
            </Tag>
          );
        })}
      </div>
    </div>
  );
};
